import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const ScreenRoot = styled(Box)({
  position: "relative",
  height: "100%",
  overflow: "hidden",
});

export const HeaderBar = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "16px 0",
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const HeaderTitles = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: 2,
});

export const HeaderOrg = styled(Typography)(({ theme }) => ({
  fontSize: 13,
  color: theme.palette.text.secondary,
}));

export const HeaderActions = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 8,
});

export const Scrim = styled(Box)({
  position: "absolute",
  inset: 0,
  background: "rgba(0, 0, 0, 0.32)",
  zIndex: 2,
});

export const DrawerPanel = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: 0,
  right: 0,
  bottom: 0,
  width: 452,
  maxWidth: "94vw",
  background: theme.palette.background.default,
  boxShadow: "-8px 0 30px rgba(0, 0, 0, 0.18)",
  zIndex: 3,
  display: "flex",
  flexDirection: "column",
}));

export const DrawerHeaderRow = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  padding: "16px 20px",
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const DrawerTitle = styled(Typography)({
  fontWeight: 700,
  textTransform: "capitalize",
});

export const DrawerMeta = styled(Box)(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  gap: "6px 12px",
  marginTop: 8,
  fontSize: 13,
  color: theme.palette.text.secondary,
}));

export const DrawerBody = styled(Box)({
  padding: "16px 20px",
  overflow: "auto",
  flex: 1,
});

export const DrawerFooter = styled(Box)(({ theme }) => ({
  padding: "14px 20px",
  borderTop: `1px solid ${theme.palette.divider}`,
  display: "flex",
  gap: 12,
}));

export const Section = styled(Box)({
  marginBottom: 20,
});

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 500,
  letterSpacing: 0.5,
  textTransform: "uppercase",
  color: theme.palette.text.secondary,
  marginBottom: 8,
}));

export const DetailGrid = styled(Box)({
  display: "grid",
  gridTemplateColumns: "130px 1fr",
  rowGap: 8,
  columnGap: 12,
  fontSize: 14,
});

export const DetailKey = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  color: theme.palette.text.secondary,
}));

export const DetailValue = styled(Typography)({
  fontSize: 14,
});

export const ServiceItem = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  fontSize: 14,
  padding: "9px 12px",
  background: theme.palette.background.paper,
  borderRadius: 8,
  marginBottom: 6,
}));

export const Callout = styled(Box)({
  borderRadius: 8,
  padding: "12px 14px",
  fontSize: 14,
  lineHeight: 1.45,
});

export const EmptyState = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  padding: "72px 20px",
  color: theme.palette.text.secondary,
}));

export const HistoryToolbar = styled(Box)({
  display: "flex",
  gap: 12,
  alignItems: "center",
  margin: "12px 0 16px",
  flexWrap: "wrap",
});

export const Reviewed = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: 2,
});
